<div class="contents-area">
  <div class="element-column">
    <div class="block-row">
      <div>
        <h1>検索条件設定(必須)</h1>
        <div class="column-list">
          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <app-order-text-with-catalog #txti_OrderCode [autofocus]="true" 
              [(ngModel)]="model.searchParams.orderCode"  (onChangedCatalogId)="model.searchParams.catalogId = $event" (ngModelChange)="changeListsRelatedOrderCode()"
              [required]="true" [forcedEnabledMode]="'true'" [tabindex]="0" width="7rem">
            </app-order-text-with-catalog>
          </div>
          <label class="list-input-title">企画回</label>
          <div class="list-input-content">
            <app-catalog-text-with-order #txti_CatalogId [autofocus]="true" 
              [(ngModel)]="model.searchParams.catalogId" (onChangedOrderCode)="model.searchParams.orderCode = $event" (ngModelChange)="changeListsRelatedOrderCode()"
              [required]="true" [forcedEnabledMode]="'true'" [tabindex]="0" width="7rem">
            </app-catalog-text-with-order>
          </div>
          <label class="list-input-title">媒体区分</label>
          <div class="list-input-content">
            <app-plan-medium-type-combo-box #cmb_MediumType id="cmb_MediumType" [subid]="'cmb_MediumType'"
              [(ngModel)]="model.searchParams.mediumType" (ngModelChange)="eventMedium_CHANGEHandler()"
              [width]="280" [tabindex]="0" forcedEnabledMode="true" [required]="true" [orderCode]="model.searchParams.orderCode">
            </app-plan-medium-type-combo-box>
          </div>
        </div>
      </div>
      <div>
        <h1>検索条件設定(任意)</h1>
        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title">特集</label>
            <div class="list-input-content">
              <app-versatile-combo-box #cmb_Feature id="cmb_Feature" [subid]="'cmb_Feature'"
                [(ngModel)]="model.searchParams.featureCode" [listSource]="model.featureList" valueField="code"
                [width]="200" labelField="name" [tabindex]="0" [visible]="true" [autofocus]="false"
                forcedEnabledMode="true">
              </app-versatile-combo-box>
            </div>
            <label class="list-input-title">部門</label>
            <div class="list-input-content">
              <app-versatile-combo-box #cmb_ClassCode id="cmb_ClassCode" [subid]="'cmb_ClassCode'"
                [(ngModel)]="model.searchParams.classCode" (ngModelChange)="eventClassCode_CHANGEHandler()"
                [listSource]="model.classCodeList" valueField="code" [width]="200" labelField="name" [tabindex]="0"
                [visible]="true" [autofocus]="false" forcedEnabledMode="true">
              </app-versatile-combo-box>
            </div>
            <label class="list-input-title">確認済フラグ</label>
            <div class="list-input-content">
              <label><input id="chk_CheckFlag" type="checkbox" [(ngModel)]="model.searchParams.checkFlag" [tabindex]="0"
                forcedEnabledMode="true" />対象</label>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">バイヤー</label>
            <div class="list-input-content">
              <app-versatile-combo-box id="cmb_Buyer" [subid]="'cmb_Buyer'" [(ngModel)]="model.searchParams.buyerCode"
                [listSource]="model.buyerList" valueField="code" [width]="200" labelField="name" [tabindex]="0"
                [visible]="true" [autofocus]="false" forcedEnabledMode="true">
              </app-versatile-combo-box>
            </div>
            <label class="list-input-title">中分類</label>
            <div class="list-input-content">
              <app-middle-class-code-combo-box #cmb_MiddleClassCode id="cmb_MiddleClassCode"
                [subid]="'cmb_MiddleClassCode'" [(ngModel)]="model.searchParams.middleClassCode"
                [classCodeComboBoxFlg]="true" [largeClassCodeComboBoxFlg]="false"
                [orderCode]="model.searchParams.orderCode" [classCode]="model.searchParams.classCode" [tabindex]="0"
                forcedEnabledMode="true" [width]="200">
              </app-middle-class-code-combo-box>
            </div>
          </div>
          <div class="column-list">

            <label class="list-input-title">ノンブル</label>
            <div class="list-input-content">
              <input type="text" id="txti_Folio" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3" [tabindex]="0"
                [(ngModel)]="model.searchParams.folio" [style.width.rem]="4" forcedEnabledMode="true" />
            </div>
            <label class="list-input-title">閾値</label>
            <div class="list-input-content">
              <div class="element-row">
                <app-versatile-combo-box id="cmb_BoundaryNum" [subid]="'cmb_BoundaryNum'"
                  [(ngModel)]="model.searchParams.boundaryNum" (ngModelChange)="eventBoundaryNum_ChangeHandler()"
                  [listSource]="model.boundaryNumList" valueField="code" [width]="100" labelField="name" [tabindex]="0"
                  [visible]="true" [autofocus]="false" forcedEnabledMode="true">
                </app-versatile-combo-box>
                <input type="text" id="txti_BoundaryNum" plessInputTextSub [restrict]="'[0-9]'" [tabindex]="0"
                  [(ngModel)]="model.searchParams.boundaryNumDetail" (blur)="eventBoundaryNumDetail_CHANGEHandler()"
                  forcedEnabledMode="true" [style.width.rem]="4" [maxlength]="3"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="btn-secondary" (click)="eventSearch_CLICKHandler()">検索</button>
  </div>

  <div>
    <h1>商品一覧</h1>
    <wj-flex-grid #dtg_GoodsList id="dtg_GoodsList" [itemsSource]="model.goodsList" [tabindex]="0"
      [allowResizing]="'Columns'" [headersVisibility]="'Column'" [isReadOnly]="true" [allowSorting]="false"
      [selectionMode]="'Row'" [deferResizing]="false" [allowDragging]="'None'" forcedEnabledMode="true">
      <wj-flex-grid-column [minWidth]="5" [width]="45" [binding]="'goodsId'" [header]="' '" [align]="'center'"
        [isReadOnly]="true" [cssClassAll]="'column-header'">
        <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'">
          <input type="checkbox" [checked]="model.isHeaderChecked" class="header-checkbox"
            (click)="eventChangeHeader_CLICKHandler();$event.stopPropagation();" [tabindex]="-1"
            [disabled]="model.isHeaderCheckboxDisabled() || !isFullControl" />
        </ng-template>
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <input type="checkbox" [checked]="model.isChecked(cell.item.pCode)"
            (click)="eventRowCheckbox_CLICKHandler(cell.item.pCode);$event.stopPropagation();" [tabindex]="-1"
            [disabled]="model.isRowCheckBoxDisabled(cell.item.pCode) || !isFullControl" />
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'計画数\n(予測)'" [width]="101"
        [binding]="'predictPlanNum'" [isReadOnly]="true" [align]="'right'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-comma-format [textAlign]="'right'" [Data]="cell.item.predictPlanNum">
          </app-comma-format>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'計画数\n(修正)'" [width]="101" [binding]="'planNum'"
        [isReadOnly]="true" [align]="'right'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-comma-format [textAlign]="'right'" [Data]="cell.item.planNum">
          </app-comma-format>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'予測差'" [width]="101" [binding]="'predictDiff'"
        [isReadOnly]="true" [align]="'right'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-comma-format [textAlign]="'right'" [Data]="cell.item.predictDiff.absValue">
          </app-comma-format>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'供給額\n(千円)'" [width]="102"
        [binding]="'supplyPrice'" [isReadOnly]="true" [align]="'right'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-comma-format [textAlign]="'right'" [Data]="cell.item.supplyPrice">
          </app-comma-format>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'特集'" [width]="120" [binding]="'feature.label'" [isReadOnly]="true">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" [width]="85" [binding]="'pCode'" [isReadOnly]="true">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'商品名'" [width]="150" [binding]="'goodsGuideName'"
        [isReadOnly]="true">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'規格名'" [width]="100" [binding]="'goodsStandardName'"
        [isReadOnly]="true">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'価格\nパターン'" [width]="65"
        [binding]="'pricePattern'" [isReadOnly]="true">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'価格プロモーション'" [width]="125" [binding]="'pricePromotion.label'"
        [isReadOnly]="true">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'登場区分'" [width]="130" [binding]="'appearDiv.label'"
        [isReadOnly]="true">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'コマ\nプロモーション'" [width]="91"
        [binding]="'komaPromotion.label'" [isReadOnly]="true">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'プロモーション\nマーク'" [width]="105"
        [binding]="'promotionMark.label'" [isReadOnly]="true">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'今回\n供給額'" [width]="90"
        [binding]="'thisTimeSupplyPrice'" [isReadOnly]="true" [align]="'right'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPrice">
          </app-comma-format>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'今回\n仕入価'" [width]="91"
        [binding]="'thisTimeCostPrice'" [isReadOnly]="true" [align]="'right'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPrice">
          </app-comma-format>
        </ng-template>
      </wj-flex-grid-column>

    </wj-flex-grid>
  </div>
</div>

<footer class="footer-buttons">
  <button id="btn_Create" class="btn-primary" [tabindex]="0" (click)="eventRegister_CLICKHandler()"
    [disabled]="model.isRegistrationDisabled() || !isFullControl">設定</button>
</footer>